/* Centrale CBD : comportements du thème (menu mobile, sliders, galerie, quantité, recommandations) */
(function () {
  'use strict';

  /* ---------- Menu mobile ---------- */
  function initMenu() {
    var drawer = document.querySelector('[data-menu]');
    var openBtn = document.querySelector('[data-menu-open]');
    if (!drawer || !openBtn) return;
    function close() { drawer.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
    function open() { drawer.hidden = false; openBtn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
    openBtn.addEventListener('click', open);
    drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('[data-menu-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ---------- Sliders produits ---------- */
  function initSliders(scope) {
    (scope || document).querySelectorAll('.section').forEach(function (sec) {
      var track = sec.querySelector('[data-slider]');
      if (!track || track.dataset.ready) return;
      track.dataset.ready = '1';
      var prev = sec.querySelector('[data-slide="prev"]');
      var next = sec.querySelector('[data-slide="next"]');
      function step() { var it = track.querySelector('.slider__item'); return it ? it.getBoundingClientRect().width + 22 : track.clientWidth; }
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Galerie produit ---------- */
  function initGallery() {
    var main = document.querySelector('.pdp__main');
    if (!main) return;
    function show(id) {
      var target = main.querySelector('[data-media="' + id + '"]');
      if (!target) return;
      main.querySelectorAll('.pdp__slide').forEach(function (s) { s.classList.toggle('is-active', s === target); });
      document.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
    }
    document.querySelectorAll('.pdp__thumb').forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.thumb); }); });
    var first = main.querySelector('.pdp__slide.is-active');
    if (first) document.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === first.dataset.media); });
    window.CentraleGallery = { show: show };
  }

  /* ---------- Quantité ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('.qty__input');
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
        input.value = v;
      });
    });
  }

  /* ---------- Produits similaires (chargés après la page) ---------- */
  function initReco() {
    var box = document.querySelector('[data-reco]');
    if (!box || !box.dataset.url) return;
    fetch(box.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-reco]');
      if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; initSliders(box.parentElement); }
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu(); initSliders(); initGallery(); initQty(); initReco();
  });
})();
